import React, { Component } from 'react';
import { Button, Image } from 'antd';
import { download as downloadFn } from '&/utils/common';

import './index.scss';

export default class HouseTypeDetail extends Component {
    download = () => {
        const { image } = this.props.house || {};
        if (!image) return;
        downloadFn(1, image);
    };
    render() {
        let { image, buildArea, indoorArea } = this.props.house || {};
        return (
            <div className="house-type-detail">
                <Image width={'20rem'} src={image} />
                <div className="house-type-info">
                    <label className="house-area-label">
                        {intl.get('decorationDesign.constructionArea') +
                            intl.get('decorationDesign.:')}
                    </label>
                    <span>{buildArea}m²</span>
                    <label className="house-area-label">
                        {intl.get('decorationDesign.realArea') +
                            intl.get('decorationDesign.:')}
                    </label>
                    <span>{indoorArea}m²</span>
                    <Button onClick={this.download}>
                        {intl.get('decorationDesign.download')}
                    </Button>
                </div>
            </div>
        );
    }
}
